/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { EdrDeploymentRegion } from './edrDeploymentRegion';


export interface EdrOrgsValidateResponse { 
    /**
     * List of EDR regions managed by VMware.
     */
    vmware_managed_regions?: Array<EdrDeploymentRegion>;
}

